<!-- Page content -->
<div class="container-fluid mt-5">
    <!-- Table -->
    <div class="row">
        <div class="col">
            <div class="card shadow">
                <div class="card-header bg-secondary border-0">
                    <h2 class="">Mon planning</h2>
                    <div class="align-items-center d-md-flex justify-content-between">
                        <h3 class="mr-3">Studio</h3>
                        <select (change)="switchToStudio($event.target.value)" [(ngModel)]="currentStudioId"
                            class="form-control" id="studio">
                            <option *ngFor="let studio of studios" [value]="studio.id">{{ studio.private_name }}
                            </option>
                        </select>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <!-- calendar -->
                            <mwl-demo-utils-calendar-header class="w-100 p-4" [(view)]="view" [(viewDate)]="viewDate"
                                [events]="events" [userType]="'manager'" (timeRangeSelected)="fillCalendarWithSelectedRange($event)">
                            </mwl-demo-utils-calendar-header>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>